export default function initFAQList() {
    const faqToggles = document.querySelectorAll('.js-faq-toggle');
    const faqList = document.querySelector('.js-faq-list');
    const faqListItems = faqList ? faqList.querySelectorAll('.js-faq-item') : null;

    faqToggles.forEach(toggle => {
        toggle.addEventListener('click', e => {
            const item = e.target.closest('.js-faq-item');

            if (item && faqList) {
                const isOpen = item.classList.contains('is-open');

                faqListItems.forEach(i => {
                    i.classList.remove('is-open');
                });

                if (!isOpen) {
                    item.classList.add('is-open');
                }
            }
        });
    });
}
